var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetChangesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78391"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16370",
    d: "M21.958 11.569c-.048-.349-.074-.7-.144-1.046A9.11 9.11 0 0018.292 4.9a9.08 9.08 0 00-7.334-1.736 8.979 8.979 0 00-4.75 2.449 11.365 11.365 0 00-1.132 1.315.821.821 0 00.581 1.32.852.852 0 00.812-.407 7.473 7.473 0 012.6-2.261 7.47 7.47 0 015.916-.544 7.473 7.473 0 013.917 2.859 7.468 7.468 0 011.41 4.03 7.435 7.435 0 01-1.178 4.475 7.521 7.521 0 01-4.419 3.291 7.317 7.317 0 01-4.639-.177 7.568 7.568 0 01-4.427-4.156c-.172-.383-.288-.791-.446-1.233a3.405 3.405 0 00.366.266.826.826 0 001.009-.209.841.841 0 00-.007-1.082q-.736-.948-1.483-1.888a1.017 1.017 0 00-1.8.146q-.335.6-.664 1.194c-.181.324-.376.64-.536.976a.823.823 0 00.837 1.185.927.927 0 00.628-.375c.017.023.029.032.033.044.01.031.017.062.024.094a9.316 9.316 0 005.549 6.473 9.2 9.2 0 004.994.58 9.076 9.076 0 004.718-2.25 9.155 9.155 0 002.971-5.291c.066-.357.1-.719.155-1.078v-1.172a1.319 1.319 0 01-.039-.169z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16371",
    d: "M17.987 12.159a5.324 5.324 0 10-5.333 5.323 5.345 5.345 0 005.333-5.323zm-6.372-.189a67.447 67.447 0 010-2.809.827.827 0 011.642-.086 6.659 6.659 0 01.023.818v1.365a.262.262 0 00.023.06h1.837a.845.845 0 01.879.6.816.816 0 01-.731 1.06q-1.336.028-2.673 0a1.026 1.026 0 01-1.001-1.008z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20903",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgResetChangesIcon;